<script>
    export default {
        props: {
            type: String
        }
    }
</script>

<template>
    <div :class="['image-link', type === 'simple' ? 'image-link--simple' : '']">
        <picture class="image-link-image image-link-image--fallback has-mask">
            <img src="/svg/one-planet.svg" alt="One Planet" loading="lazy" :width="type === 'simple' ? 509 : 455" :height="type === 'simple' ? 243 : 217">
        </picture>
        <div class="image-link-content">
            <time class="is-size-6 has-text-weight-medium mb-3 is-block">
                <progress class="progress is-medium" max="100"></progress>
            </time>
            <h3 class="title is-4 image-link-title">
                <progress class="progress is-large" max="100"></progress>
            </h3>
        </div>
    </div>
</template>
